export const enum BlockType {
  Preview = 10,
  Links = 20,
}

export const enum LinkOptions {
  SameTab = 10,
  SidePanel = 20,
  NewTab = 30,
}

export interface ResourcesBlock {
  display_block: boolean;
  block_option: BlockType;
  background_color: string;
  is_top_position: boolean;
  preview: {
    title: string;
    short_preview: string;
    link_style: string;
    link_option: LinkOptions;
    display_logo: boolean;
    logo: string;
    content: string;
    link_address: string;
    logo_size: {
      width: number;
      height: number;
    };
    logo_alignment: string;
  };
  links: {
    content: string;
    display_logo: boolean;
    link_option: LinkOptions;
    logo: string;
    name: string;
    url: string;
  }[];
}

export default interface ISIConfig {
  copy_from_intake: boolean;
  header_resources_block: ResourcesBlock;
  isi_resources_block: ResourcesBlock;
}
